import client from './client';

export const getMessages = () => {
  return client.get("/index");
}
